import { type FallbackRender } from '@sentry/react';
import { Box, Text } from '@simplywallst/ui-core';

export const ErrorDisplay: FallbackRender = () => (
  <Box>
    <Text color="bad" typography="tinyStrong">
      Something went wrong while trying to load your screeners.
    </Text>
  </Box>
);
